class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.isFeature = this.dataset.isFeature;
        this.isQuick = this.dataset.type == 'quick';
        this.doc = this.isQuick ? document.getElementById(`quick_product_${this.dataset.section}${this.isQuick ? `_${this.dataset.sectionId}`: ''}`) || document : document;
        this.addEventListener('change', this.onVariantChange, { passive: true });
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updatePrice();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }


    updateInStock(html) {
        if (this.doc) {
            this.doc.querySelector(".ml_stock").innerHTML = html;
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updatePrice() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.price) return;

        const id = `price-${this.dataset.section}`;
        const destination = this.doc?.querySelector(`#${id}`);
        const container = destination?.querySelector('.price__container');
        if(!container) return;

        const regular = container.querySelector('.price__regular');
        const sale = container.querySelector('.price__sale');

        const regularPrice = regular.querySelector('.price-item--regular');

        const salePrice = sale.querySelector('.price-item--sale');
        const saleRegularPrice = sale.querySelector('.price-item--regular');

        const price = this.currentVariant.price / 100;
        const before = this.currentVariant.compare_at_price / 100;

        if(regularPrice) {
            const toReplace = regularPrice.innerHTML?.replace(/[^0-9.]/g, '');
            regularPrice.innerHTML = regularPrice.innerHTML?.replace(toReplace, price.toFixed(2));
        }

        if(salePrice) {
            const toReplace = salePrice.innerHTML?.replace(/[^0-9.]/g, '');
            salePrice.innerHTML = salePrice.innerHTML?.replace(toReplace, price.toFixed(2));
        }

        if(saleRegularPrice) {
            const toReplace = saleRegularPrice.innerHTML?.replace(/[^0-9.]/g, '');
            saleRegularPrice.innerHTML = saleRegularPrice.innerHTML?.replace(toReplace, before.toFixed(2));
        }

    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGallery = this.doc?.querySelector(`#ML_Media_Gallery_${this.dataset.section}`);
        const thumbnail = mediaGallery?.querySelector(`[data-id="${this.currentVariant.featured_media.id}"]`);
        if (thumbnail) {
            mediaGallery.setActiveMedia(thumbnail, thumbnail.dataset.index);
        }

        // const modalContent = this.doc?.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        // const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        // modalContent.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = this.doc?.querySelector(`#Share-${this.dataset.section}`);
        if (!shareButton) return;
        shareButton?.updateUrl?.(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = this.doc?.querySelectorAll(`#product-form-${this.dataset.sectionId}, #product-form-${this.dataset.section}, #product-form-installment, #product_form_${this.dataset.sectionId}, #product_form_${this.dataset.section}, #product_form_installment`);
        productForms?.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = this.doc?.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form') || section?.querySelector(`#product-form-${this.dataset.sectionId}`) || section?.querySelector(`#product-form-${this.dataset.section}`);
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}${!this.isQuick || this.isFeature ? `&section_id=${this.isFeature ? this.dataset.sectionId : this.dataset.section}` : ''}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `price-${this.dataset.section}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = this.doc?.querySelector(`#${id}`);
                const source = html.getElementById(id);

                this.updateInStock(html.querySelector(".ml_stock").innerHTML);

                if (source && destination) destination.innerHTML = source.innerHTML;

                const price = this.doc?.querySelector(`#price-${this.dataset.section}`);

                if (price) price.classList.remove('visibility-hidden');
                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.doc?.querySelector(`#product-form-${this.dataset.sectionId}`) || this.doc?.querySelector(`#product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');

        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = this.doc?.querySelector(`#product-form-${this.dataset.sectionId}`)|| this.doc?.querySelector(`#product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = this.doc?.querySelector(`#price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
        let colors = []
        this.querySelectorAll("label").forEach((color) => {
            color.addEventListener("keypress", (e) => {
                e.preventDefault();
                
                if (e.key === "Enter") {
                    color.click();
                }
            })            
            if (color.dataset.fileUrl) {
                const colors = color.dataset.color?.toLowerCase().split(" ") || [];
                if (!this.isColor(colors)) {
                    color.style.background = `url(${color.dataset.fileUrl})`;
                    color.style.backgroundSize = "cover";
                    color.style.backgroundPosition = "center";
                    if(!color.dataset.fileUrl) {
                        color.style.background = `radial-gradient(circle, rgba(153,157,158,1) 0%, rgba(255,255,255,1) 100%)`
                    }
                } else {
                    color.style.background = this.findColor(colors)
                }
            }
        })
        this.updateOptions();
        this.changeColorTitle();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input'))?.find((radio) => radio?.checked)?.value;
        });
        this.changeColorTitle();
    }

    changeColorTitle() {
        let index = -1;
        for (let ff of this.querySelectorAll("fieldset")) {
            index += 1;
            if(ff.classList.contains('ml_color_swatches')) break;
        }

        const colorName = this.options?.[index];
        if (colorName) {
            const colorT = this.querySelector(`fieldset:nth-of-type(${index + 1}) legend .ml_color_choice_title`)
            if(colorT) {
                colorT.innerHTML = ` - ${colorName}`;
            }
        }
    }

    isColor = (strColor = []) => {
        return strColor.some(strColor => {
            const s = new Option().style;
            s.color = strColor;
            return s.color == strColor;
        })
    }

    findColor = (strColors = []) => {
        return strColors.find(strColor => {
             const s = new Option().style;
             s.color = strColor;
             return s.color == strColor;
         })
     }
}

customElements.define('variant-radios', VariantRadios);